(function ($, Global) {
    function SearchModalComponent() {
        // Déclaration class objet
    }

	SearchModalComponent.prototype.initEvents = function () {
		this.publishers();
	}

	SearchModalComponent.prototype.publishers = function () {
		$(document).on('click', '.modal-search .btn-action', function (e) {
			$('.modal-search .field-search .btn').trigger('click');
		});
	}

	Global.SearchModalComponent = SearchModalComponent;
}($, window));